import { Dialog, Transition } from "@headlessui/react";

import { ChangeEvent, FC, Fragment, useEffect, useState } from "react";
import ButtonClose from "shared/ButtonClose/ButtonClose";

import UserService from "app/services/userService";
import axios from "axios";
import Notify from "components/Notify";
import { UploadIcon } from "components/icons";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
// import ProductSubcription2 from "./ProductSubcription2";

export interface ModalSubcriptionProps {
  show: boolean;
  onCloseModalBoost: () => void;
}

const ModalBoost: FC<ModalSubcriptionProps> = ({ show, onCloseModalBoost }) => {
  const [nbBoost, setNbBoost] = useState<Number>(0);
  const [priceBoost, setNbPriceBoost] = useState<any>(100);
  const [nbBoostToBuy, setNbBoostToBuy] = useState<any>(1);
  const [image, setImage] = useState<string>();
  const [file, setFile] = useState<any>();

  const loginData = localStorage.getItem("loginData")
    ? JSON.parse(localStorage.getItem("loginData")!)
    : {
        authChecked: false,
        loggedIn: false,
        token: "",
      };
  useEffect(() => {
    UserService.get().then((data) => {
      if (data.number_of_product > 5) setNbPriceBoost(95);
      if (data.number_of_product > 50) setNbPriceBoost(90);
      if (data.number_of_product > 100) setNbPriceBoost(80);

      setNbBoost(data.boost);
    });
  }, []);

  const onClickHandler = () => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("nb_boost", nbBoostToBuy);
    if (file === undefined) {
      toast.custom((t) => (
        <Notify
          t={t}
          message="Vous devez ajouter une preuve de paiement!"
          status="error"
        />
      ));
    }
    if (file && nbBoostToBuy > 0) {
      axios
        .post(`/api/boost/`, fd, {
          headers: {
            Authorization: `Bearer ${loginData.token}`, // notice the Bearer before your token
          },
        })
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data === true) {
            toast.custom((t) => (
              <Notify
                t={t}
                message="Félicitations votre commande vient d'être enregistrée, vous serez crédité une fois la preuve de paiement vérifiée!"
                status="success"
              />
            ));
            onCloseModalBoost();
          }
        });
    }

    // fd.append('product_id', `${productId}`)
  };
  const dropImg = () => {
    setImage(String());
  };
  const selectFileHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;

    if (files && files[0]) {
      setFile(files[0]);
      setImage(URL.createObjectURL(files[0]));
    }
  };

  const { t } = useTranslation();
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50"
        onClose={onCloseModalBoost}
      >
        <div className="flex items-stretch md:items-center justify-center h-full text-center md:px-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black/40 dark:bg-black/70" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="inline-block align-middle" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="relative inline-flex xl:py-8 w-full max-w-5xl max-h-full">
              <div
                className="flex-1 flex overflow-hidden max-h-full p-8 w-full text-left align-middle transition-all transform lg:rounded-2xl bg-white
              dark:bg-neutral-900 dark:border dark:border-slate-700 dark:text-slate-100 shadow-xl"
              >
                <span className="absolute right-3 top-3 z-50">
                  <ButtonClose onClick={onCloseModalBoost} />
                </span>

                <div className="flex-1 overflow-y-auto rounded-xl hiddenScrollbar">
                  <div className="flex flex-col lg:flex-row md:flex-row">
                    <div className="flex-1 pt-2 ">
                      Vous avez actuellement {`${nbBoost}`} boost, vous pouvez
                      acheter d'autres en effectuer un paiement sur le compte
                      suivant:
                      <div>CCP : 0989987789008789</div>
                    </div>
                    <div className="flex-1 pt-2 ">
                      {image ? (
                        <div className="rounded-lg min-w-[120px]  h-60  mr-4 relative">
                          <img
                            className="rounded-lg object-cover w-full  h-60  drop-shadow-xl"
                            src={image}
                          ></img>
                          <i
                            onClick={dropImg}
                            className="las la-trash-alt absolute top-0 p-1 text-2xl text-red-600"
                          ></i>
                        </div>
                      ) : (
                        <label
                          htmlFor="dropzone-file"
                          className="flex flex-col justify-center  w-full h-60 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                        >
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <UploadIcon className="w-20 h-20" />
                            Déposer votre preuve de paiement{" "}
                            <i>
                              {" "}
                              <small> (.png, .jpg)</small>
                            </i>
                          </div>
                          <input
                            id="dropzone-file"
                            type="file"
                            className="hidden"
                            onChange={selectFileHandler}
                          />
                        </label>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-between pt-10">
                    <div>
                      <Input
                        type="number"
                        value={nbBoostToBuy}
                        onChange={(e) =>
                          setNbBoostToBuy(parseInt(e.target.value))
                        }
                        className="w-20 inline"
                      />{" "}
                      x 100 = {`${nbBoostToBuy * priceBoost}`} da
                    </div>

                    <ButtonPrimary onClick={onClickHandler}>
                      Acheter
                    </ButtonPrimary>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalBoost;
